import { GET_MEMBERS_TO_BE_DELETED } from '../../../constants/api'
import errorHandler from '../errorHandler'

export default (userAuthToken: string): Promise<string[]> =>
  fetch(GET_MEMBERS_TO_BE_DELETED(), {
    method: 'GET',
    headers: {
      Authorization: 'Bearer ' + userAuthToken,
    },
  })
    .then(errorHandler)
    .then(
      async (resp: Response): Promise<string[]> => {
        const memberIds: string[] = await resp.json()
        return memberIds
      }
    )
